<template>
    <el-dialog
        class="config_tab_dialog"
        title="合同文件"
        :visible.sync="openConfigTabDialog"
        top="4%"
        width="30%"
        :before-close="closeDialog">
       <div class="previewTabDialog">
            <el-table
            :data="tabData"
            style="width: 100%; font-size: 12px;">
            <el-table-column
                prop="fileName"
                label="合同文件名称">
            </el-table-column>
            <el-table-column
                prop="operation"
                label="操作">
                <template slot-scope="scope">
                   <span @click="previewClick(scope.row)">
                    <el-button size="mini" type="success" class="fileUrl">
                      预览
                    </el-button>
                     </span>
                        <span @click="downloadClick(scope.row)" style="margin-left:10px;">
                    <el-button size="mini" type="success" class="fileUrl">
                      下载
                    </el-button>
                     </span>
                </template>
            </el-table-column>
        </el-table>
       </div>
    </el-dialog>

</template>

<script>
import lsrmapi from '../../api/common';

export default {
    name: 'preview-tab-dialog',
    components: {},
    props: {
        openConfigTabDialog: {
            type: Boolean,
            default() {
                return false;
            }
        },
        tabData: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {

        };
    },
    methods: {
        closeDialog() {
            this.$emit('closeDialog', false);
        },
        previewClick(row) {
            var params = {
                id: row.id
            };
            lsrmapi.getPreview(params).then(res => {
                window.open(res.data.preViewUrl);
            }).catch(res => {
                this.loading = false;
            });
        },
        downloadClick(row) {
            const params = { id: row.id };
            lsrmapi.fileDownload(params).then(res => {
                const blob = new Blob([res], {
                    type: 'application/octet-stream;charset=UTF-8'
                });
                const objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = objectUrl;
                a.download = row.fileName;
                a.click();
                this.$message.success('下载成功');
            });
        }
    }
};
</script>

<style lang="less">
.previewTabDialog{
    height: 300px;
    overflow: hidden;
    overflow-y: auto;
}
</style>
